import React, { useEffect, useState } from 'react';
import './Billing.css';
import api from '../../api/axios.js'; // <-- ensure correct path
import html2pdf from 'html2pdf.js'
import InvoiceTemplate from '../../components/Invoice/InvoiceTemplate.js';
import { useRef } from 'react';
import { FiClipboard, FiUser } from 'react-icons/fi';

const Billing = () => {
  // ================= NEW STATES =================
  const [payments, setPayments] = useState([]);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [planName, setPlanName] = useState('');
  const [search, setSearch] = useState('');
  const [selectedInvoice, setSelectedInvoice] = useState(null);


  const invoiceRef = useRef();

  // ================= FETCH PLANS (FOR DROPDOWN) =================
  const fetchPlans = async () => {
    try {
      const res = await api.get('/admin/plans');
      setPlans(res.data.data || []);
    } catch (err) {
      console.error('Error fetching plans', err);
    }
  }


  const downloadInvoicePDF = (item) => {
  console.log("Invoice Data:", item);

  setSelectedInvoice(item);

  setTimeout(() => {
    html2pdf()
      .set({
        margin: 10,
        filename: `Invoice_${item.invoiceNumber}.pdf`,
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait',
        },
      })
      .from(invoiceRef.current)
      .save();
  }, 100);
};


  // ================= FETCH PAYMENTS =================
  const fetchPayments = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin/success-payment-list', {
        params: {
          page,
          limit,
          startDate,
          endDate,
          planType: planName, // <-- plan name filter
          search, // <-- vendor name / email (backend supported)
        },
      });

      setPayments(res.data.data || []);
      setTotalPages(res.data.pagination?.totalPages || 1);
    } catch (err) {
      console.error('Error fetching payments', err);
    } finally {
      setLoading(false);
    }
  }

  // ================= DOWNLOAD CSV =================
const handleDownloadCSV = async () => {
  try {
    const response = await api.get(
      '/admin/payments/success/download-csv',
      {
        params: {
          startDate,
          endDate,
          planType: planName,
          search,
        },
        responseType: 'blob', // IMPORTANT for file download
      }
    );

    // Create file from response
    const url = window.URL.createObjectURL(
      new Blob([response.data])
    );

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      `billing_${Date.now()}.csv`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error('CSV download failed', error);
  }
}

  // ================= USE EFFECTS =================
  useEffect(() => {
    fetchPlans(); // <-- load plan dropdown once
  }, []);

  useEffect(() => {
    fetchPayments(); // <-- auto refresh on filter change
  }, [page, startDate, endDate, planName, search]);

  return (
    <div className="billing">
      {/* ================= STATS (UNCHANGED) ================= */}
      <div className="billing-stats">
        <div className="stat-card">
          <div className="stat-content stc2">
            <div className="stat-info">
              <h3>Total Subscriptions</h3>
              <p className="stat-value">{payments.length}</p>
            </div>
            <div className="stat-icon leads"><FiUser /></div>
          </div>
        </div>
      </div>

      <div className="billing-section">
        <div className="billing-header">
          <h2>📄 Billing</h2>

          {/* ================= FILTER CONTROLS ================= */}
          <div className="billing-controls">
            {/* SEARCH */}
            <input
              type="text"
              placeholder="Search"
              className="billing-search"
              value={search}
              onChange={(e) => {
                setPage(1);
                setSearch(e.target.value);
              }}
            />

            {/* START DATE */}
            <input
              type="date"
              className="billing-search"
              value={startDate}
              onChange={(e) => {
                setPage(1);
                setStartDate(e.target.value);
              }}
            />

            {/* END DATE */}
            <input
              type="date"
              className="billing-search"
              value={endDate}
              onChange={(e) => {
                setPage(1);
                setEndDate(e.target.value);
              }}
            />

            {/* PLAN DROPDOWN */}
            <select
              className="billing-select"
              value={planName}
              onChange={(e) => {
                setPage(1);
                setPlanName(e.target.value);
              }}
            >
              <option value="">All Plans</option>
              {plans.map((plan) => (
                <option key={plan._id} value={plan.name}>
                  {plan.name}
                </option>
              ))}
            </select>

            <button className="download-btn" onClick={handleDownloadCSV}>Download Csv ⬇</button>
            {/* <button className="filter-btn">⚙</button> */}
          </div>
        </div>

        {/* ================= TABLE ================= */}
        <div className="billing-table-container">
          <table className="billing-table">
            <thead>
              <tr>
                <th>Vendor Name</th>
                <th>Invoice No.</th>
                <th>Subscription</th>
                <th>Amount</th>
                <th>Phone Number</th>
                <th>Date & Time</th>
                <th>Status</th> 
                <th>Invoice</th>
              </tr>
            </thead>

          <tbody>
  {loading ? (
    <tr>
      <td colSpan="8" style={{ textAlign: 'center' }}>
        Loading...
      </td>
    </tr>
  ) : payments.length === 0 ? (
    <tr>
      <td colSpan="8" style={{ textAlign: 'center' }}>
        No records found
      </td>
    </tr>
  ) : (
    payments.map((item) => (
      <tr key={item._id}>
        <td>{item.user?.name || '-'}</td>
        <td>{item.invoiceNumber}</td>
        <td>{item.plan?.name}</td>
        <td>₹{item.amount}</td>
        <td>{item.user?.mobile_number || 'N/A'}</td>

        <td>
          {new Date(item.createdAt).toLocaleDateString()} -{' '}
          {new Date(item.createdAt).toLocaleTimeString()}
        </td>

        {/* NEW STATUS COLUMN */}
        <td>
          <span
            className={`status-badge ${
              item.plan?.status === 'active'
                ? 'active'
                : 'inactive'
            }`}
          >
            {item.plan?.status || 'N/A'}
          </span>
        </td>

        <td>
          <button
            className="invoice-link"
            onClick={() => downloadInvoicePDF(item)}
          >
            Invoice.pdf
          </button>
        </td>
      </tr>
    ))
  )}
</tbody>
          </table>
        </div>

        {/* ================= PAGINATION ================= */}
        <div className="pagination">
          <button
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          <span>
            Page {page} of {totalPages}
          </span>

          <button
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      </div>

      <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
        {/* <InvoiceTemplate ref={invoiceRef} /> */}
        {selectedInvoice && (
          <InvoiceTemplate ref={invoiceRef} data={selectedInvoice} />
        )}
      </div>

    </div>
  );
};

export default Billing;
